import React from "react"
import logo from '../../images/logo.png'
import './footer.css'
import { Link } from "react-router-dom";
import environment from  '../../images/environment.pdf'

import sexual from  '../../images/Sexual_Harrasment.pdf'
import protection from '../../images/Proctection_and_Safeguarding_Policy.pdf'
import dsa from '../../images/DSAR_Policy_and_Workflow.pdf'
import lab_protection from '../../images/LAB_Privacy Policy.pdf'
import blowing from '../../images/LAB_WHISTLEBLOWING POLICY.pdf'
import safety from '../../images/Environment_Health_and_Safety_Manual.pdf'



const  FooterBlock= ()=> {

    return(
        <div

        style={{ 
      }}
              >








<footer class="footer uk-container uk-margin-large-top">
  <div class="footer-col">
    <h4 className="light">Useful Links</h4>
    <ul>
      <li><a href="#">Our Blog</a></li>
      <li><a href="#">Careers</a></li>
      <li><a href="#">Privacy Policy</a></li>
      <li><a href={environment}>Moolu Venture Lab - Environment, Health and Safety Manual</a></li>
      <li><a href={sexual}>Moolu Sexual Harassment Policy</a></li>
      <li><a href={lab_protection}>Moolu Venture Lab Data Protection Policy</a></li>
      <li><a href={dsa}>Moolu’s DSAR Form</a></li>
      <li><a href={safety}>Moolu’s Enviroment Social Governance (ESG) Compliance Policy</a></li>
      <li><a href={protection}>Moolu’s Child Protection Policy</a></li>
      <li><a href="#">Moolu’s Safeguarding Policy</a></li>
      <li><a href={blowing}>Moolu’s Whistleblowing Policy</a></li>
    </ul>
  </div>

  <div class="footer-col">
    <h4 className="light">Thematic Areas</h4>
    <ul>
      <li><Link to ="/climatic_change">Climate Change</Link></li>
      <li><Link to ="/future_of_food"> Future of Food</Link></li>
      <li><Link to ="/sustainable_energy">Sustainable Energy</Link></li>
      <li><Link to ="/digitalization_emerging_Technology">Digitalization/ Emerging Technology</Link></li>
      <li><Link to ="/creative_sectors">Creative Sectors & Industries</Link></li>
      <li><Link to ="/gender_focus_program">Gender-Focused Programming / Intervention</Link></li>
      
    </ul>
  </div>

  <div class="footer-col">
    <h4 className="light">Our Project/Programs</h4>
    <ul>
      <li><Link to ="/Nextechczar_Incubation_Program">Nextechczar Incubation Program </Link></li>
      <li><Link to="/iff_investment">	IIF Investment readiness Program</Link></li>
      <li><Link to="/giz_dtc">GIZ/DTC Digital Transformation for women and Youths</Link></li>
      <li><Link to="/market_access">Market Access</Link></li>
       <li><Link to="/ai_programs_evaluation">AI Programs/Evaluation</Link></li>
         <li><Link to="/meta_AI_LIama">Meta AI  LIama 3.0 Hackathon</Link></li>
         <li><Link to="/research_to_commercialization">Research to Commercialization</Link></li>
         
         <li><Link to="/research_to_commerce_toolkit">Research to Commercialization Toolkit Validation workshop</Link></li>
        <li><Link to="/lab_to_market"> From Lab to Market R2C Toolkit Development </Link></li>


         
    </ul>
  </div>

  <div class="footer-col">
    <h4 className="light">Stay Informed</h4>
    <ul>
        <li><a href="#">Our Blog</a></li>
         <li><a href="#">Newsletter</a></li>
         </ul>

          <h4 className="light uk-margin-large-top">Stay Informed</h4>

    <ul>
      <li><a href="#">Linkedin</a></li>
      <li><a href="#">	Facebook</a></li>
      <li><a href="#">Twittter</a></li>
      </ul>


  </div>
</footer>












            <div className=" uk-container uk-margin-large-top">
           <div  className="uk-grid uk-margin-large-top" data-uk-grid>
                <div className="uk-width-1-3@s">
                    <div className=" ">
                         <img src={logo} className="foooterLogo" />
                       
                    </div>
                </div>

                <div className="uk-width-1-3@s">
            
                </div>

                <div className="uk-width-1-3@s">
                <div class="uk-flex">
                    <a href="https://www.twitter.com/company/moliglobal" class="uk-icon-button uk-margin-medium-left  uk-margin-small-right" uk-icon="twitter"></a>
                    <a href="https://web.facebook.com/moolulab" class="uk-icon-button  uk-margin-small-right" uk-icon="facebook"></a>
                    <a href="https://www.linkedin.com/company/moolulab" class="uk-icon-button" uk-icon="linkedin"></a>
              </div>
                </div>

                
           </div>
        </div>



        {/**Social Links**/}
        <div className="uk-container socialFooterDiv uk-margin-medium-top">
           <div className="uk-grid" data-uk-grid>
               <div className="uk-width-1-3@s">
          <p class="light uk-text-small " style={{marginTop:'-30px'}}>© 2026  Moolu Venture Labs</p>
               </div>

               <div className="uk-width-1-3@s">
                  
               </div>

               <div className="uk-width-1-3@s">
               
               </div>
         </div>
          </div>

      



        </div>
    )
}


export default FooterBlock